import React from 'react';
import { CTAButton } from './CTAButton';
import { PaymentMethods } from './PaymentMethods';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const included = ['12 Tomos digitales completos', '5 Bonos exclusivos'];
export function PricingSection() {
  return <section id="oferta" className="scroll-mt-8 bg-brand-alt px-4 py-20 sm:py-24" data-id="element-129" data-mp="1j9gyormi5haf">
      <Reveal className="mx-auto max-w-2xl" data-id="element-130" data-mp="1nb263xg9p3d8">
        <SectionHeading eyebrow="Por tiempo limitado" title={<>
              <span aria-hidden="true" data-id="element-132" data-mp="1s7smklvzi0z6">🏆</span> Oferta Especial de Lanzamiento
            </>} data-id="element-131" data-mp="1naalfho7kq1q" />
        <div className="mt-12 rounded-[2rem] border border-brand-line bg-brand-cream p-7 text-center shadow-[0_18px_50px_rgba(23,32,60,0.08)] sm:p-11" data-id="element-133" data-mp="1x6ngojzejbyl">
          <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-brand-gray" data-id="element-134" data-mp="2vqsnfbtoiy5">
            Contenido del pack
          </p>
          <ul className="mt-6 space-y-4 text-left" data-id="element-135" data-mp="7vwci9bup15o">
            {included.map(item => <li key={item} className="flex items-center gap-3 border-b border-brand-line pb-4 text-sm font-medium text-brand-text" data-id="element-136" data-mp="1mhzl3iilkvf5">
                <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-brand-terra" aria-hidden="true" data-id="element-137" data-mp="1crelbrr6tkun" />
                {item}
              </li>)}
            <li className="flex items-center justify-between gap-4 pt-1 text-xs font-semibold uppercase tracking-[0.12em] text-brand-navy sm:text-sm" data-id="element-138" data-mp="25er7w1xclsny">
              <span data-id="element-139" data-mp="1vgtjnefhnvvc">Valor total</span>
              <span className="text-brand-gray line-through" data-id="element-140" data-mp="1vfryui8o7v0f">$89.990 ARS</span>
            </li>
          </ul>
          <div className="my-9 border-y border-brand-line py-9" data-id="element-141" data-mp="1rfhvldc9jip9">
            <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-brand-terra" data-id="element-142" data-mp="k38zf1oedpt8">
              Hoy pagás solo
            </p>
            <p className="mt-3 font-display text-[3rem] font-semibold leading-none tracking-tight text-brand-terra sm:text-[4.25rem]" data-id="element-143" data-mp="g2p13us38g5i">
              $19.990{' '}
              <span className="font-sans text-xl font-semibold text-brand-navy" data-id="element-144" data-mp="mfjljtqjmnse">
                ARS
              </span>
            </p>
          </div>
          <CTAButton href="https://arte-listo.impultienda.ar/checkout" className="w-full py-5" data-id="element-145" data-mp="ciolh6emgfc0">
            Quiero el Pack Arte Lista
          </CTAButton>
          <p className="mt-5 text-[11px] font-medium leading-relaxed text-brand-gray sm:text-xs" data-id="element-146" data-mp="3uuthek3uawrq">
            Descarga inmediata · Pago único · Acceso de por vida · 7 días de
            garantía
          </p>
          <PaymentMethods data-id="element-147" data-mp="3pxl1kq65z4tn" />
        </div>
      </Reveal>
    </section>;
}